// extracted by mini-css-extract-plugin
module.exports = {"manage":"manage-WJCIQ","button":"button-78ka-"};